<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('accreditations')"
          :directory="$t('Oficio Voluntario')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openRequestRSModal"
          >
            <i data-feather="plus" class="pr-2" />
            {{ $t("Oficio Voluntario") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction"/>

    <voluntary-officio-modal
      v-if="isRequestRSModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :accreditation-area-list="accreditationAreaList"
      :accreditation-activity-list="accreditationActivityList"
      :accreditation-type-list="accreditationTypeList"
      :accreditationRequestRS="accreditationRequestRS"
      @close-modal="closeRequestRSModal"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="application-delete"
      @confirmed="confirmedOfi"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este registro?"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
    name: "OfficioTable",
    extends: CoreLibrary,
    mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      isRequestRSModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "OfficioTable",
      rowData: {},
      options: {
        name: "OfficioTable",
        url: `/accreditations/officio/indexOfficio`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
        ],
        filters: [
          {
            title: "Área",
            type: "checkbox",
            key: "accreditation_area",
            option: [],
          },
          {
            title: "Actividad",
            type: "checkbox",
            key: "accreditation_activity",
            option: [],
          },
          {
            title: "Tipo",
            type: "checkbox",
            key: "accreditation_type",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    }
  },
  computed: {
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
    accreditationTypeList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationTypes,
      ];
    },
    accreditationRequestRS() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.requestRS,
      ];
    },
  },
  watch: {
    "$store.state.accreditation.accAppOptions": function () {
      this.searchAndSelectFilterOptions();
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    data() {
      this.$store.dispatch("getAccAppOptions");
    },
    openRequestRSModal() {
      this.isRequestRSModalActive = true;
    },
    closeRequestRSModal() {
      $("#application-officio-rs-modal").modal("hide");
      this.isRequestRSModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    confirmedOfi() {
      let url = `accreditations/officio/destroy/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    searchAndSelectFilterOptions() {
      const area = this.options.filters.find(
        (element) => element.key === "accreditation_area"
      );
      area.option =
        this.$store.state.accreditation.accAppOptions.accreditationAreas;

      const activity = this.options.filters.find(
        (element) => element.key === "accreditation_activity"
      );
      activity.option =
        this.$store.state.accreditation.accAppOptions.accreditationActivities;

      const type = this.options.filters.find(
        (element) => element.key === "accreditation_type"
      );
      type.option =
        this.$store.state.accreditation.accAppOptions.requestRS;  
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        if (this.rowData.status.code == "111") {
          this.selectedUrl = `/accreditations/officio/view/${rowData.id}`;
          // this.openAddEditModal();
          window.location = this.selectedUrl;
        }
      }
    },
  }

}
</script>

<style>

</style>